import { useSelector } from 'react-redux';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';

export const useQuotaWarning = (): string => {
    const isAlmostFull = useSelector(UserQuotaSelectors.isAlmostFull);
    const isOverQuota = useSelector(UserQuotaSelectors.isOverquota);
    const is100PercentFull = useSelector(UserQuotaSelectors.is100PercentFull);

    if (isAlmostFull) {
        return 'Пространство почти заполнено';
    }
    if (isOverQuota) {
        return 'Пространство переполнено';
    }
    if (is100PercentFull) {
        return 'Пространство заполнено';
    }

    return '';
};
